export default __webpack_public_path__ + "static/media/springGreen.ff8bfd6e.jpg";